/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Author } from './Author';
import type { Block } from './Block';
import type { MaterialUrl } from './MaterialUrl';
export type Material = {
    id?: string;
    feed_id?: string;
    time_min: number;
    type: string;
    url: string;
    name: string;
    short_name?: string;
    preheder_html: string;
    preheder_img_url: string;
    preview_img_url?: string;
    /**
     * Текстовая транскрибация урока для использования в RAG системе
     */
    transcript?: string;
    is_only_subscription?: boolean;
    /**
     * Minimum tariff required to access this material. NULL means available to all. Hierarchy: vip > platina > mashtab > easy_start > start
     */
    min_tariff?: Material.min_tariff | null;
    cost?: number;
    is_video: boolean;
    is_text: boolean;
    is_audio: boolean;
    is_publish: boolean;
    is_required: boolean;
    created_at?: string;
    updated_at?: string;
    publish_at?: string;
    author?: Author;
    blocks?: Array<Block>;
    material_urls?: Array<MaterialUrl>;
    is_fixed?: boolean;
};
export namespace Material {
    /**
     * Minimum tariff required to access this material. NULL means available to all. Hierarchy: vip > platina > mashtab > easy_start > start
     */
    export enum min_tariff {
        START = 'start',
        EASY_START = 'easy_start',
        MASHTAB = 'mashtab',
        PLATINA = 'platina',
        VIP = 'vip',
    }
}

